module.exports = __webpack_public_path__ + "img/menu-quadrado.801a18de.svg";